import React from 'react';
import './index.css';
import Loading from 'react-loading-components';

export default (props) => (
    <div className="row main-content d-flex align-items-center justify-content-center">
        <Loading type='tail_spin' width={100} height={100} fill='#14496b' />
    </div>
)